import api from "@/apis/OrganizationUnitTypeAPI";
import Crud from "./crud-base";
var crud = new Crud("OrganizationUnitType", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "OrganizationUnitTypeID",
      name: "OrganizationUnitTypeName",
    },
  },
};

const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
